var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.block ? _c('div', {
    staticClass: "card meta"
  }, [_c('header', {
    staticClass: "header"
  }, [_c('p', {
    staticClass: "block_type_label"
  }, [_vm._t("default")], 2), _c('h2', [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('p', {
          staticClass: "click_to_copy"
        }, [_c('span', _vm._g({
          staticClass: "block_hash",
          on: {
            "click": _vm.copy
          }
        }, on), [_vm._v(" " + _vm._s(_vm.block.number) + " ")])])];
      }
    }], null, false, 1472344482)
  }, [_c('span', [_vm._v("Click to copy")])])], 1)]), _c('div', {
    attrs: {
      "id": "block_tabs"
    }
  }, [_c('v-tabs', {
    attrs: {
      "show-arrows": ""
    },
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab', {
    attrs: {
      "href": "#overview"
    }
  }, [_vm._v("Overview")]), _vm.hasTxs ? _c('v-tab', {
    attrs: {
      "href": "#transactions"
    }
  }, [_vm._v("Transactions (" + _vm._s(_vm.block.transactions.length) + ")")]) : _vm._e(), _vm.hasAtomicTxs ? _c('v-tab', {
    attrs: {
      "href": "#atomic-transactions"
    }
  }, [_vm._v("Atomic Transactions (" + _vm._s(_vm.block.atomicTransactions.length) + ")")]) : _vm._e(), _vm.hasLogs ? _c('v-tab', {
    attrs: {
      "href": "#logs"
    }
  }, [_vm._v("Events (" + _vm._s(_vm.block.logs.length) + ")")]) : _vm._e(), _c('v-tab-item', {
    staticClass: "tab_content",
    attrs: {
      "value": "overview"
    }
  }, [_c('EVMMetadata', {
    attrs: {
      "block": _vm.block
    }
  })], 1), _vm.hasTxs ? _c('v-tab-item', {
    staticClass: "tab_content",
    attrs: {
      "value": "transactions"
    }
  }, [_c('EVMTxDataTable', {
    attrs: {
      "transactions": _vm.block.transactions
    }
  })], 1) : _vm._e(), _vm.hasAtomicTxs ? _c('v-tab-item', {
    staticClass: "tab_content",
    attrs: {
      "value": "atomic-transactions"
    }
  }, [_c('TxList', {
    attrs: {
      "transactions": _vm.block.atomicTransactions
    }
  })], 1) : _vm._e(), _vm.hasLogs ? _c('v-tab-item', {
    staticClass: "tab_content",
    attrs: {
      "value": "logs"
    }
  }, _vm._l(_vm.block.logs, function (log) {
    return _c('EVMLogRow', {
      key: log.logIndex,
      attrs: {
        "log": log
      }
    });
  }), 1) : _vm._e()], 1)], 1)]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }